import WPEmptyStates from "./WPEmptyStates";

export default WPEmptyStates;
